import React from "react";
import "./ReviewCard.scss"
import { generateRandomColorWithLighter } from "../../helper/helper";
import star from "../../assets/star.svg"
const ReviewCard = ({ review }) => {
    const value = Math.random()
    return (
        <div className="ReviewCard">
            <div className="ReviewCard-reviewcount">
                {Array.from({ length: review?.count }).map((_, index) => (
                    <img key={index} alt="star" src={star} />
                ))}
            </div>
            <div className="ReviewCard-review">
                "{review?.review}"
            </div>
            <div className="ReviewCard-profile">
                <div className="ReviewCard-profile-left"
                    style={{
                        backgroundColor: generateRandomColorWithLighter(value).lighter,
                        color: generateRandomColorWithLighter(value).original
                    }}>
                    {review?.firstName.charAt(0)}
                    {review?.lastName.charAt(0)}
                </div>
                <div className="ReviewCard-profile-right">
                    <div className="ReviewCard-profile-right-name">
                        {review?.firstName}
                        {review?.lastName}
                    </div>
                    <div className="ReviewCard-profile-right-designation">
                        {review?.designation}
                    </div>
                </div>
            </div>
        </div>
    )

}
export default ReviewCard